module.exports = __webpack_public_path__ + "img/Aquarius.5f1a0506.svg";